<template>
  <div class="debugging-container">
    <h4>接口调试</h4>
    <a-tabs v-model="activeKey" type="card" @change="responseVisible = false">
      <a-tab-pane v-for="api in apiList" :key="api.key" :tab="api.title">
        <div class="api-form">
          <a-form :form="form" layout="horizontal" :label-col="{ span: 2 }" :wrapper-col="{ span: 21 }">
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item label="请求域名" name="baseUrl">
                  <a-input
                    v-decorator="[
                      'baseUrl',
                      {
                        rules: [{ required: true, message: '请输入请求域名' }],
                        initialValue: 'https://pt.qa.growlib.com'
                      }
                    ]"
                    placeholder="请输入请求域名，如：http://localhost:8080"
                  />
                  <div class="param-tip">所有接口请求的公共域名，如：http://localhost:8080</div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item label="请求方法" name="method">
                  <a-select v-model:value="api.form.method" disabled>
                    <a-select-option :value="api.form.method">{{ api.form.method }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item label="接口路径" name="url">
                  <a-input :value="api.form.url" disabled />
                  <div class="param-tip">完整请求地址：{{ form.getFieldValue('baseUrl') }}{{ api.form.url }}</div>
                </a-form-item>
              </a-col>
            </a-row>

            <!-- <a-divider orientation="left">请求参数</a-divider> -->

            <!-- Query参数表单 -->
            <template v-if="api.form.method === 'GET' || api.form.method === 'POST'">
              <a-divider v-if="api.params.length > 0" orientation="left">Query 参数</a-divider>
              <a-form-item v-for="param in api.params" :key="param.key" :label="param.label">
                <a-input
                  v-decorator="[
                    `${api.key}_query_${param.key}`,
                    {
                      rules: [
                        {
                          required: param.required,
                          message: `请输入${param.label}`
                        }
                      ]
                    }
                  ]"
                  :placeholder="param.placeholder || `请输入${param.label}`"
                />
                <div class="param-tip">
                  {{ param.tip }}
                  <a-button type="link" v-if="param.key === 'signature'" @click="validateSignature(api)">
                    验证签名
                  </a-button>
                </div>
              </a-form-item>
            </template>

            <!-- Body参数输入框 -->
            <template v-if="api.form.method === 'POST'">
              <a-divider orientation="left">Body 参数</a-divider>
              <a-form-item label="请求体">
                <a-textarea
                  v-decorator="[
                    `${api.key}_body`,
                    {
                      rules: [
                        {
                          validator: validateJSON
                        }
                      ]
                    }
                  ]"
                  :rows="8"
                  :placeholder="dataUploadPlaceholder"
                />
                <div class="param-tip">支持JSON格式的请求体数据，可以直接粘贴JSON字符串</div>
              </a-form-item>
            </template>

            <div class="action-buttons">
              <a-button type="primary" @click="sendRequest(api)" :loading="api.loading">
                发送请求
              </a-button>
              <a-button style="margin-left: 8px" @click="resetForm(api)">
                重置
              </a-button>
            </div>

            <!-- 响应结果区域 -->
            <template v-if="responseVisible">
              <a-divider orientation="left">响应结果</a-divider>

              <div class="response-wrapper">
                <div class="close-btn">
                  <a-icon type="close" @click="responseVisible = false" />
                </div>
                <div class="response-info">
                  <p><strong>状态码：</strong> {{ responseData.status }}</p>
                  <p><strong>耗时：</strong> {{ responseData.time }}ms</p>
                </div>
                <a-tabs default-active-key="1">
                  <a-tab-pane key="1" tab="响应结果">
                    <pre
                      class="response-content"
                      :class="{ success: responseData.success, error: !responseData.success }"
                      >{{ responseData.content }}</pre
                    >
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="响应头">
                    <pre class="response-content">{{ responseData.headers }}</pre>
                  </a-tab-pane>
                </a-tabs>
              </div>
            </template>
          </a-form>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
// import axios from 'axios'  // 移除 axios 导入
import md5 from 'md5'

export default {
  name: 'Debugging',
  data() {
    return {
      form: this.$form.createForm(this),
      activeKey: 'api1',
      dataUploadPlaceholder: '如：{"username":"string","title":"string","childProjectTitle":"string","status":0,"score":0,"startTime":"string","endTime":"string","timeUsed":0,"appid":"string","originId":"string","steps":[{"seq":0,"title":"string","startTime":"string","endTime":"string","timeUsed":0,"expectTime":0,"maxScore":0,"score":0,"repeatCount":0,"evaluation":"string","scoringModel":"string","remarks":"string","extData":{}}],"groupId":"string","roleInGroup":"string","groupMembers":"string"}',
      apiList: [
        {
          key: 'api1',
          title: '获取用户信息和accessToken',
          loading: false,
          form: {
            url: '/open/api/v2/token',
            method: 'GET',
            paramType: 'params', // 添加参数类型
            paramValues: {}
          },
          params: [
            {
              key: 'appid',
              label: 'appid',
              required: true,
              tip: '填写appid，由平台分配的实验编号',
              placeholder: '如：1002'
            },
            {
              key: 'ticket',
              label: 'ticket',
              required: true,
              tip: '填写ticket令牌',
              placeholder:
                '如：7tUmhtUYGHMrkR7eGfsLbzXdKHB5IgROY7yW%2FqZCQOL0gZWyEFFed3FmWeCoY5SLf3nqhQlHLk4VMc%2BK%2BKb8SxdD7153t3M8YuSnrPqjYJ%2F2CrLzOqGiMr8SMiNtUb0Wo52%2FPDf8G39TRbUGrXAgRDQ9dSNA%2FGGZ2LD%2BUdap8NrbqYzSNCdgAhGY9uwQ79D3'
            },
            {
              key: 'secret',
              label: 'secret',
              required: false,
              tip: '填写secret, 是由"实验空间"分配给各实验平台的密钥',
              placeholder: '如：JuLowIIqF8qKibBN'
            },
            {
              key: 'signature',
              label: 'signature',
              required: true,
              tip: '填写签名',
              placeholder: '如：D1E3461EB5C609970784487B8623A0C6'
            }
          ],
          rules: {
            'paramValues.userId': [{ required: true, message: '请输入用户ID' }],
            'paramValues.token': [{ required: true, message: '请输入访问令牌' }]
          },
          signatureParams: ['ticket', 'appid', 'secret'], // 定义签名所需参数
          signatureFormula: 'MD5(ticket + appid + secret)' // 定义签名公式
        },
        {
          key: 'api2',
          title: '重新获取access_token',
          loading: false,
          form: {
            url: '/open/api/v2/token/refresh',
            method: 'GET',
            paramValues: {}
          },
          params: [
            {
              key: 'access_token',
              label: 'access_token',
              required: true,
              tip: '填写access_token，调用“获取用户信息”接口时返回的accessToken。注意，最多可有2次机会刷新accessToken',
              placeholder: '如：7tUmhtUYGHMrkR7eGfsLbzXdKHB5IgROY7yW/qZCQOL0gZWyEFFed3FmWeCoY5SLf3nqhQlHLk4VMc+K+Kb8SxdD7153t3M8YuSnrPqjYJ/2CrLzOqGiMr8SMiNtUb0Wo52/PDf8G39TRbUGrXAgRDQ9dSNA/GGZ2LD+Udap8NrbqYzSNCdgAhGY9uwQ79D3'
            },
            {
              key: 'appid',
              label: 'appid',
              required: true,
              tip: '填写appid，由平台分配的实验编号',
              placeholder: '如：1002'
            },
            {
              key: 'secret',
              label: 'secret',
              required: false,
              tip: '填写secret, 是由"实验空间"分配给各实验平台的密钥',
              placeholder: '如：JuLowIIqF8qKibBN'
            },
            {
              key: 'signature',
              label: 'signature',
              required: true,
              tip: '填写签名',
              placeholder: '如：D1E3461EB5C609970784487B8623A0C6'
            }
          ],
          rules: {
            'paramValues.name': [{ required: true, message: '请输入实验名称' }],
            'paramValues.secret': [{ required: true, message: '请输入密钥' }]
          },
          signatureParams: ['access_token', 'appid', 'secret'], // 定义签名所需参数
          signatureFormula: 'MD5(access_token + appid + secret)' // 定义签名公式
        },
        {
          key: 'api3',
          title: '实验结果数据上报',
          loading: false,
          form: {
            url: '/open/api/v2/data_upload',
            method: 'POST',
            paramValues: {}
          },
          params: []
        },
        {
          key: 'api4',
          title: '实验报告上传接口',
          loading: false,
          form: {
            url: '/open/api/v2/attachment_upload',
            method: 'GET',
            paramValues: {}
          },
          params: [
            {
              key: 'accessToken',
              label: 'accessToken',
              required: true,
              tip: '填写accessToken，接口调用令牌',
              placeholder: '如：7tUmhtUYGHMrkR7eGfsLbzXdKHB5IgROY7yW/qZCQOL0gZWyEFFed3FmWeCoY5SLf3nqhQlHLk4VMc+K+Kb8SxdD7153t3M8YuSnrPqjYJ/2CrLzOqGiMr8SMiNtUb0Wo52/PDf8G39TRbUGrXAgRDQ9dSNA/GGZ2LD+Udap8NrbqYzSNCdgAhGY9uwQ79D3'
            },
            {
              key: 'appid',
              label: 'appid',
              required: true,
              tip: '填写appid，由平台分配的实验编号',
              placeholder: '如：1002'
            },
            {
              key: 'originId',
              label: 'originId',
              required: true,
              tip: '填写originId，实验平台的实验记录ID',
              placeholder: '如：100'
            },
            {
              key: 'filename',
              label: 'filename',
              required: true,
              tip: '填写filename，上传的文件名称，需要带文件扩展名',
              placeholder: '如：实验报告.pdf'
            },
            {
              key: 'title',
              label: 'title',
              required: true,
              tip: '填写title，实验报告名称',
              placeholder: '如：实验报告'
            },
            {
              key: 'remarks',
              label: 'remarks',
              required: false,
              tip: '填写remarks，备注',
              placeholder: '如：实验报告备注'
            }
          ]
        },
        {
          key: 'api5',
          title: '获取实验结果',
          loading: false,
          form: {
            url: '/open/api/v2/data_get',
            method: 'GET',
            paramValues: {}
          },
          params: [
            {
              key: 'accessToken',
              label: 'accessToken',
              required: true,
              tip: '填写accessToken，接口调用令牌',
              placeholder: '如：7tUmhtUYGHMrkR7eGfsLbzXdKHB5IgROY7yW/qZCQOL0gZWyEFFed3FmWeCoY5SLf3nqhQlHLk4VMc+K+Kb8SxdD7153t3M8YuSnrPqjYJ/2CrLzOqGiMr8SMiNtUb0Wo52/PDf8G39TRbUGrXAgRDQ9dSNA/GGZ2LD+Udap8NrbqYzSNCdgAhGY9uwQ79D3'
            },
            {
              key: 'appid',
              label: 'appid',
              required: true,
              tip: '填写appid，由平台分配的实验编号',
              placeholder: '如：1002'
            },
            {
              key: 'start',
              label: 'start',
              required: false,
              tip: '填写start，查询开始记录，最小数为1',
              placeholder: '如：1'
            },
            {
              key: 'username',
              label: 'username',
              required: false,
              tip: '填写username，平台的用户名',
              placeholder: '如：admin@cntcvc'
            },
            {
              key: 'originId',
              label: 'originId',
              required: false,
              tip: '填写originId，实验平台实验记录ID',
              placeholder: '如：100'
            },
            {
              key: 'groupId',
              label: 'groupId',
              required: false,
              tip: '填写groupId，实验平台实验记录组ID',
              placeholder: '如：2'
            },
            {
              key: 'signature',
              label: 'signature',
              required: true,
              tip: '填写签名',
              placeholder: '如: D1E3461EB5C609970784487B8623A0C6'
            }
          ],
          signatureParams: ['accessToken', 'appid'], // 定义签名所需参数
          signatureFormula: 'MD5(accessToken + appid)' // 定义签名公式
        }
      ],
      responseVisible: false,
      responseData: {
        success: true,
        status: 200,
        time: 0,
        content: '',
        headers: {}
      }
    }
  },
  methods: {
    resetForm(api) {
      this.form.resetFields()
      api.form.paramValues = {}
    },

    // 添加 JSON 验证方法
    validateJSON(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      try {
        JSON.parse(value)
        callback()
      } catch (e) {
        callback('请输入有效的 JSON 格式')
      }
    },

    async sendRequest(api) {
      try {
        // 获取当前 API 相关的所有字段名
        const apiFields = ['baseUrl']

        // 添加 Query 参数字段
        api.params.forEach(param => {
          apiFields.push(`${api.key}_query_${param.key}`)
        })

        // 添加 Body 参数字段
        if (api.form.method === 'POST') {
          apiFields.push(`${api.key}_body`)
        }

        // 只验证当前 API 相关的字段
        const values = await new Promise((resolve, reject) => {
          this.form.validateFields(apiFields, (err, values) => {
            if (err) {
              reject(err)
            } else {
              resolve(values)
            }
          })
        })

        // 处理 Query 参数
        const queryParams = new URLSearchParams()
        api.params.forEach(param => {
          const value = values[`${api.key}_query_${param.key}`]
          if (value !== undefined && value !== '') {
            // 对 ticket 参数进行解码
            queryParams.append(param.key, param.key === 'ticket' ? decodeURIComponent(value) : value)
          }
        })

        // 处理 Body 参数
        let bodyData = null
        if (api.form.method === 'POST') {
          const bodyValue = values[`${api.key}_body`]
          if (bodyValue) {
            try {
              bodyData = JSON.parse(bodyValue)
            } catch (e) {
              // JSON 解析失败时不设置 body
            }
          }
        }

        api.loading = true
        const startTime = Date.now()

        try {
          // 构建请求 URL (包含查询参数)
          const baseUrl = values.baseUrl
          const apiUrl = api.form.url
          const url = `${baseUrl}${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`

          console.log('请求URL ----->', url)

          // 构建请求配置
          const fetchOptions = {
            method: api.form.method,
            headers: {
              'Content-Type': 'application/json'
            }
          }

          // 添加请求体
          if (api.form.method === 'POST' && bodyData !== null) {
            fetchOptions.body = JSON.stringify(bodyData)
          }

          console.log('请求配置 ----->', fetchOptions)

          // 发送请求
          const response = await fetch(url, fetchOptions)
          const endTime = Date.now()

          // 获取响应头
          const headers = {}
          response.headers.forEach((value, key) => {
            headers[key] = value
          })

          // 获取响应内容
          const responseText = await response.text()
          let responseData
          try {
            // 尝试解析为 JSON
            responseData = JSON.parse(responseText)
          } catch (e) {
            // 如果不是 JSON，则使用原始文本
            responseData = responseText
          }

          console.log('响应数据 ----->', responseData)

          // 显示响应结果
          this.responseData = {
            success: response.ok,
            status: response.status,
            time: endTime - startTime,
            content: typeof responseData === 'object' ? JSON.stringify(responseData, null, 2) : responseData,
            headers: JSON.stringify(headers, null, 2)
          }
        } catch (error) {
          console.error('请求错误:', error)
          const endTime = Date.now()

          this.responseData = {
            success: false,
            status: 'Error',
            time: endTime - startTime,
            content: error.message,
            headers: '{}'
          }
        } finally {
          api.loading = false
          this.responseVisible = true
        }
      } catch (error) {
        // 表单验证失败，不继续执行
        console.error('表单验证错误:', error)
      }
    },
    // 添加验证签名方法
    async validateSignature(api) {
      try {
        // 动态生成需要验证的字段
        const fieldsToValidate = api.signatureParams.map(param => `${api.key}_query_${param}`)

        // 只验证签名相关的字段
        await this.form.validateFields(fieldsToValidate)

        // 获取字段值
        const values = this.form.getFieldsValue()

        // 动态拼接签名字符串
        const signatureString = api.signatureParams
          .map(param => {
            const value = values[`${api.key}_query_${param}`]
            return param === 'ticket' ? decodeURIComponent(value) : value
          })
          .join('')

        console.log('原始签名 ----->', signatureString)

        // 计算签名
        const calculatedSignature = md5(signatureString).toUpperCase()

        // 获取用户输入的签名
        const userSignature = values[`${api.key}_query_signature`]

        // 比较签名
        if (calculatedSignature === userSignature) {
          this.$message.success('签名验证成功')
        } else {
          this.$message.error(`签名验证失败，正确签名为：${calculatedSignature}`)
        }
      } catch (error) {
        if (error.errorFields) {
          this.$message.error(`请先填写${api.signatureParams.join('、')}`)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.debugging-container {
  padding: 16px;
  padding-top: 20px !important;

  h4 {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .api-form {
    margin-top: 16px;
  }

  .param-tip {
    color: #888;
    font-size: 12px;
    line-height: 1.5;
  }

  .action-buttons {
    margin-top: 24px;
    text-align: center;
  }

  .response-info {
    margin-bottom: 16px;
  }

  .response-wrapper {
    margin-top: 16px;
    background: #fafafa;
    padding: 16px;
    border-radius: 4px;
    position: relative; // 添加相对定位
  }

  .close-btn {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;

    .anticon {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }

  .close-icon {
    float: right;
    cursor: pointer;
    &:hover {
      color: #1890ff;
    }
  }

  .response-content {
    padding: 16px;
    border-radius: 4px;
    max-height: 400px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-all;

    &.success {
      background-color: #f6ffed;
      border: 1px solid #b7eb8f;
    }

    &.error {
      background-color: #fff2f0;
      border: 1px solid #ffccc7;
    }
  }
  /deep/ .ant-card-body {
    padding: 24px 0px;
  }
}
</style>
